/**
 * Hook React pour les Circuit Breakers
 */

import React from 'react';
import { getCircuitBreaker, addStoppedStateObserver } from '../utils/circuit-breaker.js';

/**
 * Hook pour écouter les changements d'état des circuit breakers
 */
export function useCircuitBreakerStatus(route) {
  const [status, setStatus] = React.useState(null);

  React.useEffect(() => {
    const breaker = getCircuitBreaker(route);
    setStatus(breaker.getStatus());

    const unsubscribe = breaker.addListener(setStatus);
    
    // S'abonner au changement d'état "stopped" pour forcer une mise à jour
    const unsubscribeStoppedState = addStoppedStateObserver(() => {
      const updatedBreaker = getCircuitBreaker(route);
      setStatus(updatedBreaker.getStatus());
    });
    
    return () => {
      unsubscribe();
      unsubscribeStoppedState();
    };
  }, [route]);

  return status;
}

/**
 * Hook pour écouter les changements d'état de tous les circuit breakers
 */
export function useAllCircuitBreakerStatus() {
  const [statuses, setStatuses] = React.useState({});

  React.useEffect(() => {
    const routes = [
      '/api/ia/text',
      '/api/ia/vision', 
      '/api/ia/translation',
      '/api/wa',
      '/api/config'
    ];

    const unsubscribers = [];

    routes.forEach(route => {
      const breaker = getCircuitBreaker(route);
      const unsubscribe = breaker.addListener((status) => {
        setStatuses(prev => ({
          ...prev,
          [route]: status
        }));
      });
      unsubscribers.push(unsubscribe);

      // Initialiser le statut
      setStatuses(prev => ({
        ...prev,
        [route]: breaker.getStatus()
      }));
    });

    return () => {
      unsubscribers.forEach(unsub => unsub());
    };
  }, []);

  return statuses;
}
